import { vec3 } from 'gl-matrix';
import { Scene } from '../Scene';
import { SceneManifest } from '../SceneManifest';
import { Light, PointLight, DirectionalLight, SpotLight } from '../../light';

export function loadLights(scene: Scene, manifest: SceneManifest): void {
  for (const lightDef of manifest.lights) {
    const pos = lightDef.position;
    const color = lightDef.color
      ? vec3.fromValues(lightDef.color[0], lightDef.color[1], lightDef.color[2])
      : undefined;
    const specular = lightDef.specular
      ? vec3.fromValues(lightDef.specular[0], lightDef.specular[1], lightDef.specular[2])
      : undefined;
    const shadowMode = lightDef.shadowMode;
    const priority = lightDef.priority;

    let light: Light;
    switch (lightDef.type) {
      case 'point':
        light = new PointLight({
          reference: lightDef.reference,
          position: pos,
          color,
          specular,
          innerRange: lightDef.innerRange!,
          outerRange: lightDef.outerRange!,
          shadowMode,
          priority,
        });
        break;
      case 'directional':
        light = new DirectionalLight({
          reference: lightDef.reference,
          position: pos,
          color,
          specular,
          direction: lightDef.direction!,
          shadowMode,
          priority,
        });
        break;
      case 'spot':
        light = new SpotLight({
          reference: lightDef.reference,
          position: pos,
          color,
          specular,
          innerRange: lightDef.innerRange!,
          outerRange: lightDef.outerRange!,
          dotInnerLimit: lightDef.dotInnerLimit!,
          dotOuterLimit: lightDef.dotOuterLimit!,
          direction: lightDef.direction!,
          shadowMode,
          priority,
        });
        break;
    }

    scene.lightManager.addLight(light);
  }

  if (manifest.ambientLight) {
    scene.lightManager.ambientColor = vec3.fromValues(
      manifest.ambientLight[0],
      manifest.ambientLight[1],
      manifest.ambientLight[2],
    );
  }
}
